import { render, staticRenderFns } from "./mdc-list.vue?vue&type=template&id=20992b12&scoped=true&"
import script from "./mdc-list.vue?vue&type=script&lang=ts&"
export * from "./mdc-list.vue?vue&type=script&lang=ts&"
import style0 from "./mdc-list.vue?vue&type=style&index=0&id=20992b12&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20992b12",
  null
  
)

export default component.exports